import React from "react";
import Navbar from "../Components/Navbar";
import Contact from "../Components/Contact";

function ContactPage() {
  return (
    <>
      <Navbar />
      <Contact />
    </>
  );
}

export default ContactPage;
